import { http } from '../../../api/axios';
import { collectionConfig } from '../../../config';
import { ProductCopyDetails } from '../../../store/api';

export const apiFetchProductCopies = async (productId: string) => {
    return http
        .get<ProductCopyDetails[]>(collectionConfig().endpointProductCopyDetails, {
            pathParams: {
                id: productId
            }
        })
        .then(res => res.data);
};
